module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form,
      "label-width": "auto",
      "label-position": "left"
    }
  }, [(!_vm.isEditor || (_vm.isEditor && !_vm.form.item_main_cat_id)) ? [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.mainCateLoader),
      expression: "mainCateLoader"
    }],
    attrs: {
      "shadow": "never",
      "header": "选择主分类"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "360px"
    },
    attrs: {
      "options": _vm.mainCategory
    },
    on: {
      "change": _vm.handleCategoryChange
    },
    model: {
      value: (_vm.selectedMainCategory),
      callback: function($$v) {
        _vm.selectedMainCategory = $$v
      },
      expression: "selectedMainCategory"
    }
  })], 1)] : _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    staticClass: "content-padded view-flex view-flex-middle"
  }, [_c('div', [_vm._v("主分类：")]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "inline",
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, _vm._l((_vm.categoryNames), function(item, index) {
    return _c('el-breadcrumb-item', {
      key: index
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1), _vm._v(" "), ((!_vm.isEditor && _vm.selectedMainCategory.length > 0) || _vm.isEditor) ? [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("基础信息")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.panelCollapse('base')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.panel.base ? 'icon-window-minimize1' : 'icon-plus'
  })])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panel.base),
      expression: "panel.base"
    }],
    staticClass: "form-collapse"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*商品标题"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 50,
      "placeholder": "",
      "disabled": true
    },
    model: {
      value: (_vm.form.item_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "item_name", $$v)
      },
      expression: "form.item_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "副标题"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 140,
      "placeholder": "",
      "disabled": true
    },
    model: {
      value: (_vm.form.brief),
      callback: function($$v) {
        _vm.$set(_vm.form, "brief", $$v)
      },
      expression: "form.brief"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "计量单位"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 60,
      "placeholder": "",
      "disabled": true
    },
    model: {
      value: (_vm.form.item_unit),
      callback: function($$v) {
        _vm.$set(_vm.form, "item_unit", $$v)
      },
      expression: "form.item_unit"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "排序编号"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "",
      "disabled": true
    },
    model: {
      value: (_vm.form.sort),
      callback: function($$v) {
        _vm.$set(_vm.form, "sort", $$v)
      },
      expression: "form.sort"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "产地"
    }
  }, [_c('el-cascader', {
    attrs: {
      "disabled": true,
      "placeholder": "选择地区",
      "options": _vm.regions
    },
    on: {
      "change": _vm.regionChange
    },
    model: {
      value: (_vm.select_regions_value),
      callback: function($$v) {
        _vm.select_regions_value = $$v
      },
      expression: "select_regions_value"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*商品图"
    }
  }, [_c('div', [_c('div', {
    staticClass: "pics-box"
  }, [_c('ul', {
    staticClass: "goodspic-wrap"
  }, [_c('draggable', {
    staticClass: "components-view",
    attrs: {
      "options": _vm.dragIssuesOptions
    },
    model: {
      value: (_vm.form.pics),
      callback: function($$v) {
        _vm.$set(_vm.form, "pics", $$v)
      },
      expression: "form.pics"
    }
  }, _vm._l((_vm.form.pics), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "goodspic",
      on: {
        "mouseenter": function($event) {
          return _vm.picsEnter(index)
        },
        "mouseleave": _vm.picsLeave
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.wximageurl + item
      }
    })])
  }), 0)], 1)])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上传视频"
    }
  }, [_c('videoPicker', {
    attrs: {
      "data": _vm.itemVideo
    },
    on: {
      "change": _vm.pickVideo
    }
  })], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("是否特殊商品类型")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.panelCollapse('goods_type')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.panel.goods_type ? 'icon-window-minimize1' : 'icon-plus'
  })])], 1), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.special_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "special_type", $$v)
      },
      expression: "form.special_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "normal",
      "disabled": true
    }
  }, [_vm._v("普通商品")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "drug",
      "disabled": true
    }
  }, [_vm._v("处方药")])], 1)], 1), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("商品参数")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "padding": "3px 0"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.panelCollapse('param')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont",
    class: _vm.panel.param ? 'icon-window-minimize1' : 'icon-plus'
  })])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panel.param),
      expression: "panel.param"
    }],
    staticClass: "form-collapse"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, _vm._l((_vm.params), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "xs": 24,
        "sm": 12,
        "md": 8,
        "lg": 6
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": item.label
      }
    }, [(item.children.length > 0) ? _c('el-select', {
      attrs: {
        "placeholder": "请选择"
      },
      model: {
        value: (_vm.form.item_params[index].attribute_value_id),
        callback: function($$v) {
          _vm.$set(_vm.form.item_params[index], "attribute_value_id", $$v)
        },
        expression: "form.item_params[index].attribute_value_id"
      }
    }, _vm._l((item.children), function(child) {
      return _c('el-option', {
        key: child.value,
        attrs: {
          "disabled": true,
          "label": child.label,
          "value": child.value
        }
      })
    }), 1) : _c('el-input', {
      attrs: {
        "maxlength": 60,
        "placeholder": "",
        "disabled": true
      },
      model: {
        value: (_vm.form.item_params[index].attribute_value_name),
        callback: function($$v) {
          _vm.$set(_vm.form.item_params[index], "attribute_value_name", $$v)
        },
        expression: "form.item_params[index].attribute_value_name"
      }
    })], 1)], 1)
  }), 1)], 1)])], 1), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "shadow": "never"
    }
  }, [_c('div', {
    staticClass: "view-flex",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "view-flex-item"
  }, [_vm._v("商品规格")]), _vm._v(" "), (!_vm.isEditor) ? [(_vm.skus.length === 0) ? _c('span', {
    staticClass: "small mark"
  }, [_vm._v("添加多规格商品请先为当前主类目绑定规格!")]) : _vm._e(), _vm._v(" "), (_vm.skus.length > 0) ? [_c('el-switch', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#efefef",
      "active-text": "统一规格",
      "inactive-text": "多规格"
    },
    model: {
      value: (_vm.form.nospec),
      callback: function($$v) {
        _vm.$set(_vm.form, "nospec", $$v)
      },
      expression: "form.nospec"
    }
  })] : _vm._e()] : _vm._e(), _vm._v(" "), (!_vm.form.nospec) ? [_c('span', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("是否在商详页成列图片规格")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.form.is_show_specimg),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_show_specimg", $$v)
      },
      expression: "form.is_show_specimg"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), (_vm.form.nospec) ? [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品状态",
      "render-header": _vm.renderRequire
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.approve_status),
      callback: function($$v) {
        _vm.$set(_vm.form, "approve_status", $$v)
      },
      expression: "form.approve_status"
    }
  }, _vm._l((_vm.statusOption), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "库存"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.store),
      callback: function($$v) {
        _vm.$set(_vm.form, "store", $$v)
      },
      expression: "form.store"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品货号"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 60,
      "placeholder": ""
    },
    model: {
      value: (_vm.form.item_bn),
      callback: function($$v) {
        _vm.$set(_vm.form, "item_bn", $$v)
      },
      expression: "form.item_bn"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "重量"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.weight),
      callback: function($$v) {
        _vm.$set(_vm.form, "weight", $$v)
      },
      expression: "form.weight"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("kg")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "体积"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.volume),
      callback: function($$v) {
        _vm.$set(_vm.form, "volume", $$v)
      },
      expression: "form.volume"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("m³")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "销售价"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.price),
      callback: function($$v) {
        _vm.$set(_vm.form, "price", $$v)
      },
      expression: "form.price"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("¥")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "成本价"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.cost_price),
      callback: function($$v) {
        _vm.$set(_vm.form, "cost_price", $$v)
      },
      expression: "form.cost_price"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("¥")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "原价"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.market_price),
      callback: function($$v) {
        _vm.$set(_vm.form, "market_price", $$v)
      },
      expression: "form.market_price"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("¥")])], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "条形码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "required": "",
      "min": "0",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.barcode),
      callback: function($$v) {
        _vm.$set(_vm.form, "barcode", $$v)
      },
      expression: "form.barcode"
    }
  })], 1)], 1)], 1)] : [(_vm.specImages.length > 0) ? _c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('div', {
    staticClass: "content-padded h3"
  }, [_vm._v("设置规格图片")]), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.specImages,
      "header-cell-style": {
        background: '#f5f7fa'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "规格",
      "prop": "item_spec",
      "width": "240"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "规格图"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._l((scope.row.item_image_url), function(item, index) {
          return _c('imgBox', {
            key: index,
            attrs: {
              "imgUrl": item,
              "inline": "",
              "removeBtn": "",
              "width": "50",
              "height": "50"
            },
            on: {
              "remove": function($event) {
                return _vm.handleImgRemove(scope.$index, index)
              }
            }
          })
        }), _vm._v(" "), (scope.row.item_image_url.length < 5) ? _c('imgBox', {
          attrs: {
            "width": "50",
            "height": "50",
            "inline": ""
          },
          on: {
            "click": function($event) {
              return _vm.handleSkuImg(scope.$index)
            }
          }
        }) : _vm._e()]
      }
    }], null, false, 2505365326)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-padded h3"
  }, [_vm._v("设置规格")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "*状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "size": "mini",
            "placeholder": "请选择"
          },
          model: {
            value: (scope.row.approve_status),
            callback: function($$v) {
              _vm.$set(scope.row, "approve_status", $$v)
            },
            expression: "scope.row.approve_status"
          }
        }, _vm._l((_vm.statusOption), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.title,
              "size": "mini",
              "value": item.value
            }
          })
        }), 1)]
      }
    }], null, false, 863906553)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.store),
            callback: function($$v) {
              _vm.$set(scope.row, "store", $$v)
            },
            expression: "scope.row.store"
          }
        })]
      }
    }], null, false, 3794582033)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "maxlength": 60,
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.item_bn),
            callback: function($$v) {
              _vm.$set(scope.row, "item_bn", $$v)
            },
            expression: "scope.row.item_bn"
          }
        })]
      }
    }], null, false, 1632943470)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "maxlength": 60,
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.weight),
            callback: function($$v) {
              _vm.$set(scope.row, "weight", $$v)
            },
            expression: "scope.row.weight"
          }
        })]
      }
    }], null, false, 1004554920)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体积"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "maxlength": 60,
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.volume),
            callback: function($$v) {
              _vm.$set(scope.row, "volume", $$v)
            },
            expression: "scope.row.volume"
          }
        })]
      }
    }], null, false, 220252480)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "销售价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.price),
            callback: function($$v) {
              _vm.$set(scope.row, "price", $$v)
            },
            expression: "scope.row.price"
          }
        })]
      }
    }], null, false, 3082212771)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "成本价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.cost_price),
            callback: function($$v) {
              _vm.$set(scope.row, "cost_price", $$v)
            },
            expression: "scope.row.cost_price"
          }
        })]
      }
    }], null, false, 1858449783)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "原价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.market_price),
            callback: function($$v) {
              _vm.$set(scope.row, "market_price", $$v)
            },
            expression: "scope.row.market_price"
          }
        })]
      }
    }], null, false, 1576021176)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "条形码"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          model: {
            value: (scope.row.barcode),
            callback: function($$v) {
              _vm.$set(scope.row, "barcode", $$v)
            },
            expression: "scope.row.barcode"
          }
        })]
      }
    }], null, false, 170721298)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": _vm.fillSku
          }
        }, [_vm._v("填充")])]
      }
    }], null, false, 4151920980)
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.specItems[_vm.currentPage - 1],
      "header-cell-style": {
        background: '#f5f7fa'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "规格值"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.item_spec), function(item) {
          return _c('span', [_vm._v("\n                  " + _vm._s(item.spec_custom_value_name || item.spec_value_name) + "\n                ")])
        })
      }
    }], null, false, 2317793094)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "render-header": _vm.renderRequire
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          attrs: {
            "size": "mini",
            "placeholder": "请选择"
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.approve_status),
            callback: function($$v) {
              _vm.$set(scope.row, "approve_status", $$v)
            },
            expression: "scope.row.approve_status"
          }
        }, _vm._l((_vm.statusOption), function(item) {
          return _c('el-option', {
            key: item.value,
            attrs: {
              "label": item.title,
              "size": "mini",
              "value": item.value
            }
          })
        }), 1)]
      }
    }], null, false, 328860283)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "库存",
      "render-header": _vm.renderRequire
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.store),
            callback: function($$v) {
              _vm.$set(scope.row, "store", $$v)
            },
            expression: "scope.row.store"
          }
        })]
      }
    }], null, false, 1326944115)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "货号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "maxlength": 60,
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.item_bn),
            callback: function($$v) {
              _vm.$set(scope.row, "item_bn", $$v)
            },
            expression: "scope.row.item_bn"
          }
        })]
      }
    }], null, false, 233076972)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "重量(kg)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "maxlength": 60,
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.weight),
            callback: function($$v) {
              _vm.$set(scope.row, "weight", $$v)
            },
            expression: "scope.row.weight"
          }
        })]
      }
    }], null, false, 2168900074)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "体积(m³)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "maxlength": 60,
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.volume),
            callback: function($$v) {
              _vm.$set(scope.row, "volume", $$v)
            },
            expression: "scope.row.volume"
          }
        })]
      }
    }], null, false, 4047312514)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "销售价",
      "render-header": _vm.renderRequire
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.price),
            callback: function($$v) {
              _vm.$set(scope.row, "price", $$v)
            },
            expression: "scope.row.price"
          }
        })]
      }
    }], null, false, 1463242945)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "成本价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.cost_price),
            callback: function($$v) {
              _vm.$set(scope.row, "cost_price", $$v)
            },
            expression: "scope.row.cost_price"
          }
        })]
      }
    }], null, false, 2879515797)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "原价"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.market_price),
            callback: function($$v) {
              _vm.$set(scope.row, "market_price", $$v)
            },
            expression: "scope.row.market_price"
          }
        })]
      }
    }], null, false, 1215015674)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "条形码"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number",
            "required": "",
            "min": "0",
            "size": "mini",
            "placeholder": ""
          },
          on: {
            "change": function($event) {
              return _vm.upadateState(scope.row)
            }
          },
          model: {
            value: (scope.row.barcode),
            callback: function($$v) {
              _vm.$set(scope.row, "barcode", $$v)
            },
            expression: "scope.row.barcode"
          }
        })]
      }
    }], null, false, 4081517456)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.specPagesize,
      "layout": "prev, pager, next",
      "total": _vm.specTotal
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1)]], 2), _vm._v(" "), _c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "header": "图文详情",
      "shadow": "never"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "模式"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.mode),
      callback: function($$v) {
        _vm.mode = $$v
      },
      expression: "mode"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 'richText'
    }
  }, [_vm._v("富文本")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'component'
    }
  }, [_vm._v("组件式")])], 1)], 1), _vm._v(" "), (_vm.mode === 'richText') ? [_c('vue-html5-editor', {
    attrs: {
      "content": _vm.form.intro,
      "height": 360
    }
  })] : [_c('richTextEditor', {
    attrs: {
      "data": _vm.content,
      "control": ['film', 'slider', 'heading', 'writing']
    },
    on: {
      "change": _vm.handleContent
    }
  })]], 2), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.form.audit_status == 'processing') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-edit"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("审核商品")]) : _vm._e()], 1)] : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "审核商品",
      "visible": _vm.dialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.authForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核状态"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.authForm.audit_status),
      callback: function($$v) {
        _vm.$set(_vm.authForm, "audit_status", $$v)
      },
      expression: "authForm.audit_status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "approved"
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "rejected"
    }
  }, [_vm._v("拒绝")])], 1)], 1), _vm._v(" "), (_vm.authForm.audit_status == 'rejected') ? _c('el-form-item', {
    attrs: {
      "label": "拒绝原因"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.authForm.audit_reason),
      callback: function($$v) {
        _vm.$set(_vm.authForm, "audit_reason", $$v)
      },
      expression: "authForm.audit_reason"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a01d08a8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a01d08a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/audit/add.vue
// module id = 2891
// module chunks = 0